import React from 'react'
import { Redirect,  Switch } from 'react-router-dom'
import { ContentRoute } from '../../../_metronic/layout' 
import FirmwareFileList from './list/FirmwareFileList'

export default function FirmwareFilePage() {
    return (
        <Switch>

            <Redirect exact={true} from="/firmware-file" to="/firmware-file/list" />
            <ContentRoute from={ "/firmware-file/list"} component={FirmwareFileList} />
        </Switch>
    )
}
